import { IdentityTypeDecorator } from "../decorators/identity-type.decorator";
import { CoreModel } from "./core-model";
import { ModelTypeNameDecorator } from "./decorators/model-type-name.decorator";
import { DynamicExternalIdentity } from "./dynamic-external.identity";

@IdentityTypeDecorator(DynamicExternalIdentity)
@ModelTypeNameDecorator('DynamicExternal')
export class DynamicExternal extends CoreModel<DynamicExternalIdentity> {

}